import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Site, SiteUpdate } from '../../../core/site/site';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { TranslateService } from '@ngx-translate/core';
import { PhpVersionChangeComponent } from '../php-version-change/php-version-change.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { PhpVersionService } from '../../../core/php-version';
import { map } from 'rxjs/operators';
import { AccountsService } from '../../../accounts.service';
import { SiteService } from '../../../core/site';
import { AdvancedSiteSettingsApiService, GetSubscribedCountResponse } from '@vendasta/wsp-wp-manager';
import { MULTISITE_EDITION_NAME } from '../../../../globals';
@Component({
  selector: 'app-manage-site',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './manage-site.component.html',
  styleUrls: ['./manage-site.styles.scss'],
  standalone: false,
})
export class ManageSiteComponent implements OnInit {
  @Input() domain: string;
  @Input() siteId: string;
  @Input() editURL: string;

  _siteUpdate: SiteUpdate;
  coreUpToDate = false;
  manageSiteModalHeader: string;
  phpVersion$: Observable<any>;
  phpVersion;
  editionName$: Observable<string>;
  SubscribedsubsitesCount$: Observable<number> = of(0);
  readonly MULTISITE_EDITION_NAME = MULTISITE_EDITION_NAME;

  @Input() partnerId: string;

  @Input() set siteUpdate(siteUpdate: SiteUpdate) {
    if (siteUpdate) {
      this._siteUpdate = siteUpdate;
      this.coreUpToDate = siteUpdate.core_version === siteUpdate.latest_core_version;
    }
  }
  @Input() set siteUpdateErr(siteUpdateErr: boolean) {
    if (siteUpdateErr) {
      this._siteUpdate = {
        php_version: null,
        core_version: null,
        latest_core_version: null,
        num_of_plugin_updates: null,
        num_of_theme_updates: null,
      };
    }
  }

  constructor(
    private sanitizer: DomSanitizer,
    private snowplow: ProductAnalyticsService,
    private translate: TranslateService,
    public modal: MatDialog,
    private phpVersionService: PhpVersionService,
    private accountsService: AccountsService,
    private siteService: SiteService,
    private advancedSiteSettingsApiService: AdvancedSiteSettingsApiService,
  ) {
    this.phpVersion$ = this.phpVersionService
      .getPhpVersionState$()
      .pipe(map((phpVersionState) => phpVersionState.sitePhpVersion));

    this.editionName$ = this.accountsService.editionName$;
    const siteId = this.siteService.get().pipe(map((site: Site) => site.siteId));

    siteId.subscribe((siteId: string) => {
      this.advancedSiteSettingsApiService
        .getSubscribedCount({ siteId: siteId })
        .pipe(map((response: GetSubscribedCountResponse) => response.subscribedCount))
        .subscribe((count: number) => {
          this.SubscribedsubsitesCount$ = of(count);
          if (count === undefined) {
            this.SubscribedsubsitesCount$ = of(0);
          }
        });
    });
  }

  ngOnInit(): void {
    this.manageSiteModalHeader =
      this.translate.instant('PAGES.OVERVIEW.MANAGE_SITE_MODAL.HEADER') +
      `</br><a class="plain-link accent-font" target="_blank" href="https://${this.domain}">${this.domain}</a>`;
    console.log(this.manageSiteModalHeader);
    this.phpVersionService.loadPhpVersionState();
  }

  public siteUrl(): SafeResourceUrl {
    if (!this.domain) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://${this.domain}?display=iframe`);
  }

  updatePluginURL(): string {
    return '/redirect/wp-admin/' + this.siteId + '/?redirect_to=' + encodeURIComponent('wp-admin/plugins.php');
  }

  updateCoreURL(): string {
    return '/redirect/wp-admin/' + this.siteId + '/?redirect_to=' + encodeURIComponent('wp-admin/update-core.php');
  }

  updateThemeURL(): string {
    return '/redirect/wp-admin/' + this.siteId + '/?redirect_to=' + encodeURIComponent('wp-admin/themes.php');
  }

  openModal(): void {
    this.phpVersion$.subscribe((e) => {
      this.phpVersion = e;
    });
    this.modal.open(PhpVersionChangeComponent, {
      width: '500px',
      data: {
        php_version: this.phpVersion,
        wp_version: this._siteUpdate.core_version,
      },
    });
  }
}
